import { useLang } from "@/context/LangContext";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink text-paper/70 border-t border-paper/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 font-mono text-[0.7rem] tracking-[0.25em] uppercase">
        <p>© {year} Simone Orfanò — {t.footer.rights}</p>
        <p className="text-paper/40">{t.footer.builtWith}</p>
      </div>
    </footer>
  );
};

export default Footer;
